import React from 'react';
import { useIntl } from 'react-intl-next';
import { selectionToolbarMessages } from '@atlaskit/editor-common/messages';
import { PinnedIcon, ToolbarButton, ToolbarTooltip } from '@atlaskit/editor-toolbar';
export var PinButton = function PinButton(_ref) {
  var api = _ref.api;
  var intl = useIntl();
  var message = intl.formatMessage(selectionToolbarMessages.toolbarPositionPinedAtTop);
  var onClick = function onClick() {
    var _api$selectionToolbar, _api$selectionToolbar2;
    if (!api) {
      return;
    }
    (_api$selectionToolbar = api.selectionToolbar.actions) === null || _api$selectionToolbar === void 0 || (_api$selectionToolbar2 = _api$selectionToolbar.setToolbarDocking) === null || _api$selectionToolbar2 === void 0 || _api$selectionToolbar2.call(_api$selectionToolbar, 'none');
  };
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: message
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(PinnedIcon, {
      size: "small",
      label: ""
    }),
    label: message,
    onClick: onClick
  }));
};